<script setup lang="ts">
    import { inject } from 'vue';
    import { ScheduledItem } from '../DashboardTypes';
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import { formatDateTime } from '@shared/utils/formatDateTime';
    import { DashboardAccess } from '@views/Dashboard/Dashboard.access';
    import IssueSubject from '@cwd/Views/Issues/IssueSubject.vue';

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const dashboardAccess: DashboardAccess = injectorAccess.injector.get(DashboardAccess);

    const props = defineProps<{ item: ScheduledItem }>();
</script>

<template>
    <template v-if="item.Type === 'Issue'">
        <h4 class="item-heading">
            <a :href="item.ListUrl">
                <IssueSubject :subject="item.Title" :dynamic-subject="item.DynamicSubject" />
            </a>
            <button
                type="button"
                class="btn btn-subtle btn-xs"
                v-tooltip.top="$Resources.IssuePreviewButton"
                @click="dashboardAccess.previewObject(item.Url + '?preview=true')">
                <span class="glyphicon glyphicon-eye-open" aria-hidden="true"></span>
            </button>
        </h4>
        <p class="meta">
            <span class="m-md-r">
                <span class="glyphicon glyphicon-envelope"></span>
                {{ $Resources.ItemTypeIssue }}
            </span>
            <span class="m-md-r">
                <span class="glyphicon glyphicon-time"></span>
                <span v-text="formatDateTime(item.ScheduledTo)"></span>
            </span>
            <span class="m-md-r" v-if="item.LastModifiedBy">
                <span class="glyphicon glyphicon-user"></span>
                <span v-text="item.LastModifiedBy.Name"></span>
            </span>
        </p>
    </template>

    <template v-if="item.Type === 'Event2Dto'">
        <h4>
            <RouterLink :to="item.ListUrl">{{ item.Title || $Resources.NoTitlePlaceholder }}</RouterLink>
            <button
                type="button"
                class="btn btn-subtle btn-xs m-0-b"
                v-tooltip.top="$Resources.IssuePreviewButton"
                @click="dashboardAccess.previewObject(item.Url + '?preview=true')">
                <span class="glyphicon glyphicon-eye-open" aria-hidden="true"></span>
            </button>
        </h4>
        <p class="meta">
            <span class="m-md-r">
                <span class="glyphicon glyphicon-calendar"></span>
                {{ $Resources.ItemTypeEvent }}
            </span>
            <span class="m-md-r">
                <span class="glyphicon glyphicon-time"></span>
                <span v-text="formatDateTime(item.ScheduledTo)"></span>
            </span>
            <span class="m-md-r" v-if="item.LastModifiedBy">
                <span class="glyphicon glyphicon-user"></span>
                <span v-text="item.LastModifiedBy.Name"></span>
            </span>
        </p>
    </template>

    <template v-if="item.Type === 'SmsMessageDto'">
        <h4>
            <a :href="item.ListUrl" v-text="item.Title ? item.Title : $Resources.NoTitlePlaceholder"></a>
        </h4>
        <p class="meta">
            <span class="m-md-r">
                <span class="glyphicon glyphicon-phone"></span>
                {{ $Resources.ItemTypeSmsMessage }}
            </span>
            <span class="m-md-r">
                <span class="glyphicon glyphicon-time"></span>
                <span v-text="formatDateTime(item.ScheduledTo)"></span>
            </span>
            <span class="m-md-r" v-if="item.LastModifiedBy">
                <span class="glyphicon glyphicon-user"></span>
                <span v-text="item.LastModifiedBy.Name"></span>
            </span>
        </p>
    </template>
</template>

<style scoped></style>
